import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TaskType } from '@fitness-force/enum';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'task-type-report',
  templateUrl: './task-type-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, RippleModule, StyleClassModule, AsyncPipe],
})
export class TaskTypeReportComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  task!: TaskType;

  getEnumKeyByEnumValue(enumValue: number | string): string {
    let keys = Object.keys(TaskType).filter(
      (x: any) => TaskType[x] == enumValue,
    );
    return keys.length > 0 ? keys[0] : '';
  }
}
